(ns shared.core.amelia-light.components.components
  (:require [shared.core.amelia-light.components.button :as button]
            [shared.core.amelia-light.components.card :as card]
            [shared.core.amelia-light.components.checkbox :as checkbox]
            [shared.core.amelia-light.components.date-picker :as date-picker]
            [shared.core.amelia-light.components.dialog.views :as dialog]
            [shared.core.amelia-light.components.dropdown :as dropdown]
            [shared.core.amelia-light.components.icon :as icon]
            [shared.core.amelia-light.components.input :as input]
            [shared.core.amelia-light.components.loading :as loading]
            [shared.core.amelia-light.components.panel :as panel]
            [shared.core.amelia-light.components.pill :as pill]
            [shared.core.amelia-light.components.sheet :as sheet]
            [shared.core.amelia-light.components.sidebar :as sidebar]
            [shared.core.amelia-light.components.tab :as tab]
            [shared.core.amelia-light.components.table :as table]
            [shared.core.amelia-light.components.tag :as tag]
            [shared.core.amelia-light.components.toggle :as toggle]
            [shared.core.amelia-light.components.toggle-group :as toggle-group]
            [shared.core.amelia-light.components.tooltip :as tooltip]
            [shared.core.amelia-light.components.waffle-menu :as waffle-menu]))

(def searchable-dropdown dropdown/searchable-dropdown)
(def dropdown dropdown/dropdown)
(def up-dropdown dropdown/up-dropdown)
(def up-multiple-dropdown dropdown/up-multiple-dropdown)
(def up-popover dropdown/up-popover)
(def up-popover-button-dropdown dropdown/up-popover-button-dropdown)
(def up-searchable-list dropdown/up-searchable-list)

(def up-dropdown-menu dropdown/up-dropdown-menu)
(def up-dropdown-menu-trigger dropdown/up-dropdown-menu-trigger)
(def up-dropdown-menu-content dropdown/up-dropdown-menu-content)
(def up-dropdown-menu-item dropdown/up-dropdown-menu-item)
(def up-dropdown-menu-label dropdown/up-dropdown-menu-label)
(def up-dropdown-menu-separator dropdown/up-dropdown-menu-separator)
(def up-dropdown-menu-group dropdown/up-dropdown-menu-group)
(def up-dropdown-menu-sub dropdown/up-dropdown-menu-sub)
(def up-dropdown-menu-sub-trigger dropdown/up-dropdown-menu-sub-trigger)
(def up-dropdown-menu-sub-content dropdown/up-dropdown-menu-sub-content)

(def material-icon icon/material-icon)
(def up-icon icon/up-icon)
(def up-secondary-icon icon/up-secondary-icon)

(def input input/input)
(def textarea input/textarea)

(def up-input input/up-input)
(def up-textarea input/up-textarea)
(def up-password-input input/up-password-input)
(def up-label input/up-label)
(def up-input-group input/up-input-group)
(def up-input-group-addon input/up-input-group-addon)
(def up-input-group-button input/up-input-group-button)
(def up-input-group-text input/up-input-group-text)
(def up-input-group-input input/up-input-group-input)
(def up-input-group-textarea input/up-input-group-textarea)
(def up-input-group-clear-button input/up-input-group-clear-button)

(def white-button button/white-button)
(def white-circle-icon-button button/white-circle-icon-button)
(def purple-button button/purple-button)
(def button-group-toggle button/button-group-toggle)
(def up-button button/up-button)
(def up-ghost-button button/up-ghost-button)
(def up-call-to-action-button button/up-call-to-action-button)
(def up-toggle-pressed-button button/up-toggle-pressed-button)

(def checkbox checkbox/checkbox)
(def up-checkbox checkbox/up-checkbox)

(def date-range-picker date-picker/date-range-picker)

(def gray-spinner loading/gray-spinner)
(def gray-spinner-with-label loading/gray-spinner-with-label)
(def up-loader loading/up-loader)
(def up-loader-with-label loading/up-loader-with-label)

(def pill-button pill/pill-button)
(def pill-button-group pill/pill-button-group)

(def table table/table)
(def table-header-style table/table-header-style)
(def download-csv-button table/download-csv-button)

(def up-tabs tab/up-tabs)
(def up-tabs-root tab/up-tabs-root)
(def up-tabs-list tab/up-tabs-list)
(def up-tabs-trigger tab/up-tabs-trigger)
(def up-tabs-content tab/up-tabs-content)

(def up-tag tag/up-tag)

(def up-toggle toggle/up-toggle)

(def up-toggle-group toggle-group/up-toggle-group)
(def up-toggle-group-item toggle-group/up-toggle-group-item)

(def tooltip tooltip/tooltip)

(def up-sidebar-provider sidebar/up-sidebar-provider)
(def up-sidebar sidebar/up-sidebar)
(def up-sidebar-content sidebar/up-sidebar-content)
(def up-sidebar-header sidebar/up-sidebar-header)
(def up-sidebar-footer sidebar/up-sidebar-footer)
(def up-sidebar-group sidebar/up-sidebar-group)
(def up-sidebar-group-label sidebar/up-sidebar-group-label)
(def up-sidebar-menu sidebar/up-sidebar-menu)
(def up-sidebar-menu-item sidebar/up-sidebar-menu-item)
(def up-sidebar-menu-button sidebar/up-sidebar-menu-button)
(def up-sidebar-menu-sub sidebar/up-sidebar-menu-sub)
(def up-sidebar-menu-sub-item sidebar/up-sidebar-menu-sub-item)
(def up-sidebar-menu-sub-button sidebar/up-sidebar-menu-sub-button)
(def up-sidebar-trigger sidebar/up-sidebar-trigger)
(def use-sidebar sidebar/use-sidebar)

(def up-sheet sheet/up-sheet)
(def up-sheet-content sheet/up-sheet-content)
(def up-sheet-header sheet/up-sheet-header)
(def up-sheet-title sheet/up-sheet-title)
(def up-sheet-description sheet/up-sheet-description)

(def card card/card)
(def up-card card/up-card)
(def up-card-header card/up-card-header)
(def up-card-footer card/up-card-footer)
(def up-card-title card/up-card-title)
(def up-card-action card/up-card-action)
(def up-card-description card/up-card-description)
(def up-card-content card/up-card-content)

(def up-waffle-menu waffle-menu/up-waffle-menu)

(def dialog-view dialog/dialog-view)
(def dialog dialog/dialog)
(def active-dialog dialog/active-dialog)
(def up-dialog dialog/up-dialog)
(def up-dialog-trigger dialog/up-dialog-trigger)
(def up-dialog-close dialog/up-dialog-close)
(def up-dialog-content dialog/up-dialog-content)
(def up-dialog-header dialog/up-dialog-header)
(def up-dialog-body dialog/up-dialog-body)
(def up-dialog-footer dialog/up-dialog-footer)
(def up-dialog-title dialog/up-dialog-title)
(def up-dialog-description dialog/up-dialog-description)
(def up-dialog-portal dialog/up-dialog-portal)

(def up-panel-layout panel/up-panel-layout)
(def up-panel-left panel/up-panel-left)
(def up-panel-right panel/up-panel-right)
(def up-panel-header panel/up-panel-header)
(def up-panel-header-property panel/up-panel-header-property)
(def up-panel-header-upsert panel/up-panel-header-upsert)
(def up-panel-grid panel/up-panel-grid)
